var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.5 22.5H46.5C45.12 22.5 44 23.62 44 25V25.56C43.41 25.21 42.73 25 42 25H26.79C26.4 24.12 25.52 23.5 24.5 23.5H22.5C21.48 23.5 20.6 24.12 20.21 25H16V24C16 22.35 14.65 21 13 21H7C6.65 21 6.31 21.07 6 21.18V16.5C6 15.12 4.88 14 3.5 14H2.5C1.12 14 0 15.12 0 16.5V37.5C0 38.88 1.12 40 2.5 40H3.5C4.88 40 6 38.88 6 37.5V35H44V37.5C44 38.88 45.12 40 46.5 40H47.5C48.88 40 50 38.88 50 37.5V25C50 23.62 48.88 22.5 47.5 22.5ZM4 37.5C4 37.78 3.78 38 3.5 38H2.5C2.22 38 2 37.78 2 37.5V16.5C2 16.22 2.22 16 2.5 16H3.5C3.78 16 4 16.22 4 16.5V37.5ZM22 26C22 25.72 22.22 25.5 22.5 25.5H24.5C24.78 25.5 25 25.72 25 26V29H22V26ZM6 24C6 23.45 6.45 23 7 23H13C13.55 23 14 23.45 14 24V25H6V24ZM6 27H20V29H6V27ZM44 33H6V31H44V33ZM27 29V27H42C43.1 27 44 27.9 44 29H27ZM48 37.5C48 37.78 47.78 38 47.5 38H46.5C46.22 38 46 37.78 46 37.5V25C46 24.72 46.22 24.5 46.5 24.5H47.5C47.78 24.5 48 24.72 48 25V37.5Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35 22C41.07 22 46 17.07 46 11C46 4.93 41.07 0 35 0C28.93 0 24 4.93 24 11C24 17.07 28.93 22 35 22ZM35 2C39.96 2 44 6.04 44 11C44 15.96 39.96 20 35 20C30.04 20 26 15.96 26 11C26 6.04 30.04 2 35 2Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.5 14H32V16.5C32 17.05 32.45 17.5 33 17.5H37C37.55 17.5 38 17.05 38 16.5V14H40.5C41.05 14 41.5 13.55 41.5 13V9C41.5 8.45 41.05 8 40.5 8H38V5.5C38 4.95 37.55 4.5 37 4.5H33C32.45 4.5 32 4.95 32 5.5V8H29.5C28.95 8 28.5 8.45 28.5 9V13C28.5 13.55 28.95 14 29.5 14ZM30.5 10H33C33.55 10 34 9.55 34 9V6.5H36V9C36 9.55 36.45 10 37 10H39.5V12H37C36.45 12 36 12.45 36 13V15.5H34V13C34 12.45 33.55 12 33 12H30.5V10Z",
    fill: "#0A71FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI3);
export default __webpack_public_path__ + "static/media/i3.e47b4f52badbba0c7587d4dd5691a05d.svg";
export { ForwardRef as ReactComponent };